var _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUiCartAwareness(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon-ui--cart-awareness_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-ui--cart-awareness_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 13v-2h4v2h-4zm1.2 7L14 17.6l1.2-1.6 3.2 2.4-1.2 1.6zm-2-12L14 6.4 17.2 4l1.2 1.6L15.2 8z",
    fill: "#000"
  }))));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-ui--cart-awareness-86193358508050d74f6008176933cba5.svg";
export { SvgIconUiCartAwareness as Component };